import { useEffect, useRef, useState } from 'react';

const useWaitingForGoogleMaps = () => {
  const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);
  const timeoutIdRef = useRef<number | null>(null);

  useEffect(() => {
    const checkGoogleMaps = () => {
      if (window.google?.maps) {
        setIsGoogleMapsLoaded(true);
      } else {
        timeoutIdRef.current = window.setTimeout(checkGoogleMaps, 100);
      }
    };
    timeoutIdRef.current = window.setTimeout(checkGoogleMaps, 100);
    return () => {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }
    };
  }, []);

  return isGoogleMapsLoaded;
};

export default useWaitingForGoogleMaps;
